import React from "react";
import FilterByDateRange from "./FilterByDateRange";

const TopHeader = ({ setSearchTerm, searchTerm }) => {
  return (
    <div className="mb-10 flex flex-wrap gap-2 items-center justify-between">
      <div className="min-w-[200px]">
        <span className="border-left fs-22 gray-color tx-upp">
          Sales History
        </span>
      </div>

      <FilterByDateRange {...{ setSearchTerm, searchTerm }} />
    </div>
  );
};

export default TopHeader;
